import { processMediaFileUrl } from '../../../utils/media';
/**
 * 이미지 URL 처리 유틸리티 함수
 * 다양한 형식의 URL을 적절히 변환하여 이미지 소스로 사용할 수 있게 함
 */ export var processImageUrl = function(url, options) {
    var internalBlobUrl = options.internalBlobUrl, imageBlob = options.imageBlob, log = options.log;
    log('[processImageUrl] 시작:', {
        url: url,
        internalBlobUrl: !!internalBlobUrl,
        imageBlob: !!imageBlob
    });
    if (!url || url.trim() === '') {
        log('[processImageUrl] 빈 URL 반환');
        return '';
    }
    // 내부에서 생성한 Blob URL이 있으면 우선 사용
    if (internalBlobUrl && imageBlob) {
        return internalBlobUrl;
    }
    // '_placeholder_' 값이 들어오면 확인해서 File 객체가 있으면 그걸 사용
    if (url === '_placeholder_' && imageBlob) {
        return internalBlobUrl || '';
    }
    try {
        // blob: 또는 data:로 시작하는 로컬 URL은 그대로 사용
        if (url.startsWith('blob:') || url.startsWith('data:')) {
            log('[processImageUrl] blob/data URL 반환:', url);
            return url;
        }
        // 이미 HTTP/HTTPS URL이면 그대로 사용
        if (url.startsWith('http://') || url.startsWith('https://')) {
            log('[processImageUrl] http(s) URL 반환:', url);
            return url;
        }
        // `/images/` 또는 `/assets/`로 시작하는 경로는 변환하지 않고 그대로 사용
        if (url.startsWith('/images/') || url.startsWith('/assets/')) {
            log('[processImageUrl] 로컬 정적 에셋 경로 반환:', url);
            return url;
        }
        // API 기반 경로 처리
        if (url.startsWith('/') || !url.includes('://')) {
            log('미디어 파일 API 경로 처리 시도:', url);
            var processedUrl = processMediaFileUrl(url);
            if (processedUrl) {
                log('[processImageUrl] 최종 변환된 API URL 반환:', processedUrl);
                return processedUrl;
            }
        }
        // 그 외의 경우 그대로 반환
        return url;
    } catch (error) {
        console.error("URL 처리 중 오류: ".concat(error));
        return '';
    }
};
